@if (initialized) {
    <div class="grid">
        <div class="col-12">
            @if (busy) {
                <div class="text-center p-4">
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                </div>
            } @else if (columnData) {
                <div class="p-card">
                    <div class="p-card-body">
                        <h4>{{ columnData.headerName || columnData.originalName }}</h4>
                        <div class="grid mt-3">
                            <div class="col-6">
                                <label class="font-semibold">Data Type</label>
                                <p>{{ columnData.detectedDataType }}</p>
                            </div>
                            <div class="col-6">
                                <label class="font-semibold">Null Percentage</label>
                                <p>{{ columnData.nullPercentage }}%</p>
                            </div>
                            <div class="col-6">
                                <label class="font-semibold">Unique Count</label>
                                <p>{{ columnData.uniqueCount }}</p>
                            </div>
                            <div class="col-6">
                                <label class="font-semibold">Is Unique</label>
                                <p>{{ columnData.isUnique ? 'Yes' : 'No' }}</p>
                            </div>
                            <div class="col-6">
                                <label class="font-semibold">PII Type</label>
                                <p>{{ columnData.piiType || 'None' }}</p>
                            </div>
                            <div class="col-6">
                                <label class="font-semibold">Sensitivity Level</label>
                                <p>{{ columnData.sensitivityLevel || 'None' }}</p>
                            </div>
                            @if (columnData.minStringLength != null) {
                                <div class="col-6">
                                    <label class="font-semibold">String Length (Min/Avg/Max)</label>
                                    <p>{{ columnData.minStringLength }} / {{ columnData.avgStringLength }} / {{ columnData.maxStringLength }}</p>
                                </div>
                            }
                            @if (columnData.detectedDateFormat) {
                                <div class="col-6">
                                    <label class="font-semibold">Date Format</label>
                                    <p>{{ columnData.detectedDateFormat }}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            } @else {
                <div class="text-center p-4 text-secondary">
                    Select a column to view details
                </div>
            }
        </div>
    </div>
}
